import { type EntityPathBuilder, getResolvedPath } from '../../../util/routing/entity-paths';

export const ROUTE_RULE_BASE_PATH = getResolvedPath('/clearing/operations/oms/routing-rule');

export const getRouteRulePath: EntityPathBuilder<{ ruleId: string }> = (context) => {
  switch (context.kind) {
    case 'list':
      return ROUTE_RULE_BASE_PATH;
    case 'detail': {
      if (!context?.keys?.ruleId) {
        return undefined;
      }

      return getResolvedPath(`${ROUTE_RULE_BASE_PATH}/$ruleId`, context?.keys);
    }
  }
};

export function getRouteRuleDetailPath(ruleId: string | undefined) {
  if (!ruleId) {
    return undefined;
  }

  return getRouteRulePath({ kind: 'detail', keys: { ruleId } });
}
